import { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Switch,
  FormControlLabel,
  Modal,
  Box,
  Typography,
  Stack,
  Divider,
  CircularProgress
} from "@mui/material";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import HelpIcon from "@mui/icons-material/Help";
import { Postrequestcall } from "../../../request/Postrequest";
import {
  DELETE_GOALS,
  DELETE_GOLE_CATEGORIES_ID,
  SAVE_GOALS,
  SAVE_GOALS_CATEGORIES
} from "../../../constant/Apipath";
import { useSelector } from "react-redux";
import DeleteConfirmation from "../../common/DeleteConfirmation";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import { setShowalert } from "../../../redux/actions/actions";
import { useDispatch } from "react-redux";
import { English } from "../../../constant/EnglishFallback";

const AddGoalModal = ({ 
  open, 
  onClose, 
  editGoalDetails, 
  loginData, 
  onDataSave 
}) => {
  const { multiLanguageData } = useSelector((state) => state?.main);
  const dispatch = useDispatch();

  // Self-managed state (moved from context)
  const [isUntrackedHours, setIsUntrackedHours] = useState(false);
  const [categories, setCategories] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [goalName, setGoalName] = useState("");
  const [totalHours, setTotalHours] = useState("");
  const [untrackedHours, setUntrackedHours] = useState("");
  const [categoryError, setCategoryError] = useState(false);
  const [deletePrompt, setDeletePrompt] = useState(false);

  const LanguageData = multiLanguageData?.TimeSheet || {};
  const {
    TEXT_ADD_GOAL = English.TimeSheet.TEXT_ADD_GOAL,
    TEXT_EDIT_GOAL = English.TimeSheet.TEXT_EDIT_GOAL,
    TEXT_GOAL_NAME_PLACEHOLDER = English.TimeSheet.TEXT_GOAL_NAME_PLACEHOLDER,
    TEXT_TOTAL_HOURS = English.TimeSheet.TEXT_TOTAL_HOURS,
    TEXT_UNTRACKED_HOURS = English.TimeSheet.TEXT_UNTRACKED_HOURS,
    TEXT_OPTIONAL_CATEGORY_NOTE = English.TimeSheet.TEXT_OPTIONAL_CATEGORY_NOTE,
    BUTTON_ADD_CATEGORY = English.TimeSheet.BUTTON_ADD_CATEGORY,
    TEXT_CATEGORY_NAME = English.TimeSheet.TEXT_CATEGORY_NAME,
    TEXT_UNTRACKED_HOURS_FOR_CATEGORY = English.TimeSheet.TEXT_UNTRACKED_HOURS_FOR_CATEGORY,
    TEXT_DIALOG_INFO = English.TimeSheet.TEXT_DIALOG_INFO,
    DIALOG_DELETE_DESCRIPTION = English.TimeSheet.DIALOG_DELETE_DESCRIPTION,
    TEXT_DIALOG_DELETE_GOALS_CATEGORIES = English.TimeSheet.TEXT_DIALOG_DELETE_GOALS_CATEGORIES,
    BUTTON_DELETE = English.TimeSheet.BUTTON_DELETE
  } = LanguageData || {};

  // Initialize form data when editGoalDetails changes
  useEffect(() => {
    if (editGoalDetails) {
      setGoalName(editGoalDetails?.name ?? "");
      setIsUntrackedHours(editGoalDetails?.untrackedHoursFlag ?? false);
      setTotalHours(editGoalDetails?.totalHours ?? "");
      setUntrackedHours(editGoalDetails?.untrackedHours ?? "");
      setCategories(editGoalDetails?.categoryList ?? []);
    } else {
      // Reset for new goal
      setGoalName("");
      setIsUntrackedHours(false);
      setTotalHours("");
      setUntrackedHours("");
      setCategories([]);
    }
  }, [editGoalDetails, open]);

  const handleClose = () => {
    // Reset all form state
    setGoalName("");
    setIsUntrackedHours(false);
    setTotalHours("");
    setUntrackedHours("");
    setCategories([]);
    setCategoryError(false);
    setDeletePrompt(false);
    setIsSaving(false);
    onClose();
  };

  const handleIsUntrackedHours = (e) => {
    setIsUntrackedHours(e.target.checked);
  };

  const handleAddCategory = () => {
    setCategoryError(false);
    if (isUntrackedHours) {
      setCategories([...categories, { categoryName: "", untrackedHours: "", id: 0 }]);
    } else {
      setCategories([...categories, { categoryName: "", id: 0 }]);
    }
  };

  const handleRemoveCategory = async (category, index) => {
    const newCategories = [...categories];
    newCategories.splice(index, 1);
    setCategories(newCategories);

    // Delete category from backend if it has an ID
    if (category?.id > 0) {
      try {
        const obj = {
          UserId: loginData?.userInformation?.UserId,
          ReturnRecordId: false,
          ReturnRecordError: true,
          DeleteList: [
            {
              Id: category?.id,
              ModifiedBy: loginData?.userInformation?.UserId
            }
          ]
        };
        await Postrequestcall(DELETE_GOLE_CATEGORIES_ID, obj, loginData?.accessToken);
      } catch (error) {
        console.error("handleRemoveCategory-> Error deleting category: ", error);
      }
    }
  };

  const handleCategoryChange = (index, type, value) => {
    const cleanedValue = value.replace(/^[^A-Za-z0-9]+/, "");
    const newCategories = [...categories];
    newCategories[index][type] = cleanedValue;
    setCategories(newCategories);
  };

  const onGoalSave = async () => {
    try {
      setIsSaving(true);
      
      // Validation
      if (goalName?.trim() === "" || Number(totalHours) <= 0) {
        setCategoryError(true);
        setIsSaving(false);
        return;
      }

      const checkCategoryEmpty = categories?.filter((item) => item.categoryName === "");
      if (checkCategoryEmpty?.length > 0) {
        setCategoryError(true);
        setIsSaving(false);
        return;
      }

      // Save goal
      const obj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: editGoalDetails?.id ?? 0,
            Name: goalName,
            TotalHours: Number(totalHours),
            UntrackedHoursFlag: isUntrackedHours,
            UntrackedHours: Number(untrackedHours) === "" ? 0 : Number(untrackedHours),
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };

      const res = await Postrequestcall(SAVE_GOALS, obj, loginData?.accessToken);
      const currentGoalId = res?.data.data[0]?.objData?.id;

      await onGoalCategorySave(currentGoalId);
    } catch (err) {
      console.log("onGoalSave-> Error While Saving Goal: ", err);
      setIsSaving(false);
    }
  };

  const onGoalCategorySave = async (goalId) => {
    try {
      if (categories?.length !== 0) {
        const obj = {
          UserId: loginData?.userInformation?.UserId,
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: categories.map((category) => ({
            Id: category?.id ?? 0,
            GoalId: Number(goalId),
            CategoryName: category.categoryName,
            UntrackedHours: Number(category?.untrackedHours ?? 0),
            ModifiedBy: loginData?.userInformation?.UserId
          }))
        };
        await Postrequestcall(SAVE_GOALS_CATEGORIES, obj, loginData?.accessToken);
      }
      
      // Notify parent component of successful save
      if (onDataSave) {
        await onDataSave();
      }
      
      handleClose();
    } catch (err) {
      console.log("onGoalCategorySave-> Error While Saving Goal Category: ", err);
      setIsSaving(false);
    }
  };

  const onDeleteButtonPressed = async () => {
    try {
      const deleteObj = {
        UserId: Number(loginData?.userInformation?.UserId),
        ReturnRecordId: false,
        ReturnRecordError: true,
        DeleteList: [
          {
            Id: editGoalDetails?.id,
            ModifiedBy: Number(loginData?.userInformation?.UserId)
          }
        ]
      };
      
      await Postrequestcall(DELETE_GOALS, deleteObj, loginData?.accessToken);
      
      // Notify parent component of successful delete
      if (onDataSave) {
        await onDataSave();
      }
      
      handleClose();
    } catch (err) {
      console.log("onDeleteButtonPressed-> Error While Deleting Goal: ", err);
    }
  };

  const handleTotalHoursChange = (e) => {
    const value = e.target.value;
    if (value >= 0 || value === "") {
      setTotalHours(value);
    }
  };

  const handleUntrackedHoursChange = (e) => {
    const value = e.target.value;
    if (value >= 0 || value === "") {
      setUntrackedHours(value);
    }
  };

  const handleShowAlert = () => {
    let alertObj = {
      showAlert: true,
      text: TEXT_DIALOG_INFO
    };
    dispatch(setShowalert(alertObj));
  };

  return (
    <>
      <Modal open={open} onClose={handleClose} closeAfterTransition>
        <Box className="user-modal-responsive">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between"
            }}>
            <Typography variant="h6" sx={{ ml: 1 }}>
              {editGoalDetails ? TEXT_EDIT_GOAL : TEXT_ADD_GOAL}
            </Typography>
            <Stack direction={"row"}>
              <IconButton onClick={handleClose} disabled={isSaving}>
                <CloseIcon />
              </IconButton>
              <IconButton color="primary" onClick={onGoalSave} disabled={isSaving}>
                {isSaving ? <CircularProgress size={24} color="inherit" /> : <SaveIcon />}
              </IconButton>

              {editGoalDetails && (
                <IconButton
                  disabled={isSaving}
                  color="secondary"
                  onClick={() => {
                    setDeletePrompt(true);
                  }}>
                  <DeleteIcon />
                </IconButton>
              )}
            </Stack>
          </Box>

          <Stack  sx={{ gap: 2, marginTop: 1 }}>
            <TextField
              error={categoryError && goalName === ""}
              variant="outlined"
              type="text"
              label={TEXT_GOAL_NAME_PLACEHOLDER}
              fullWidth
              onChange={(e) => {
                let inputValue = e.target.value;
                inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                setGoalName(inputValue);
              }}
              value={goalName}
              disabled={isSaving}
            />

            <TextField
              error={categoryError && Number(totalHours) <= 0}
              type="text"
              variant="outlined"
              label={TEXT_TOTAL_HOURS}
              fullWidth
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 4 && /^\d*$/.test(value)) {
                  handleTotalHoursChange(e);
                }
              }}
              value={totalHours}
              inputProps={{ maxLength: 4 }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              disabled={isSaving}
            />

            {isUntrackedHours && (
              <TextField
                variant="outlined"
                label={TEXT_UNTRACKED_HOURS}
                fullWidth
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 4 && /^\d*$/.test(value)) {
                    handleUntrackedHoursChange(e);
                  }
                }}
                value={untrackedHours}
                inputProps={{ maxLength: 4 }}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                disabled={isSaving}
              />
            )}
            
            <Stack sx={{ display: "flex", alignItems: "center" }} direction={"row"}>
              <FormControlLabel
                control={
                  <Switch 
                    size="small" 
                    checked={isUntrackedHours} 
                    onChange={handleIsUntrackedHours}
                    disabled={isSaving}
                  />
                }
                label={TEXT_UNTRACKED_HOURS}
              />
              <IconButton onClick={handleShowAlert} size="small" disabled={isSaving}>
                <HelpIcon />
              </IconButton>
            </Stack>
            
            <Typography sx={{ color: "text.secondary" }}>{TEXT_OPTIONAL_CATEGORY_NOTE}</Typography>
            
            <Box sx={{ maxHeight: "200px", overflow: "auto", scrollbarWidth: "0px", pt: 1 }}>
              {categories?.map((category, index) => (
                <Stack sx={{ display: "flex", width: "100%" }} direction={"row"} key={index}>
                  <Stack sx={{ pb: 2, alignItems: "center", width: "100%" }} spacing={2} direction="row">
                    <Stack
                      spacing={2}
                      direction="column"
                      sx={{ alignItems: "stretch", width: "100%" }}>
                      <TextField
                        id="outlined-error"
                        error={categoryError && category?.categoryName?.trim() === ""}
                        variant="outlined"
                        label={TEXT_CATEGORY_NAME}
                        placeholder={TEXT_CATEGORY_NAME}
                        fullWidth
                        value={category.categoryName}
                        onChange={(e) =>
                          handleCategoryChange(index, "categoryName", e.target.value)
                        }
                        disabled={isSaving}
                      />
                      {isUntrackedHours && (
                        <TextField
                          variant="outlined"
                          label={TEXT_UNTRACKED_HOURS_FOR_CATEGORY}
                          fullWidth
                          value={category?.untrackedHours === 0 ? "" : category?.untrackedHours}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value.length <= 4 && /^\d*$/.test(value)) {
                              handleCategoryChange(index, "untrackedHours", value);
                            }
                          }}
                          inputProps={{ maxLength: 4 }}
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          disabled={isSaving}
                        />
                      )}
                    </Stack>
                    <IconButton 
                      size="small" 
                      onClick={() => handleRemoveCategory(category, index)}
                      disabled={isSaving}>
                      <CloseIcon />
                    </IconButton>
                  </Stack>
                </Stack>
              ))}
            </Box>

            <Stack>
              <Divider />
              <Button onClick={handleAddCategory} variant="text" disabled={isSaving}>
                {BUTTON_ADD_CATEGORY}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      <DeleteConfirmation
        open={deletePrompt}
        onClose={() => {
          setDeletePrompt(false);
        }}
        headerText={TEXT_DIALOG_DELETE_GOALS_CATEGORIES}
        secondaryText={DIALOG_DELETE_DESCRIPTION}
        redButtonText={BUTTON_DELETE}
        onBadgeClick={() => onDeleteButtonPressed()}
        actionBtnText={BUTTON_DELETE}
      />
    </>
  );
};

export default AddGoalModal;
